export const capitalise = (word?: string) => {
  if (!word) {
    return word;
  }

  if (word === 'ec2') {
    return 'EC2';
  }

  return word
    .toLocaleLowerCase()
    .replace(/\w/, (firstLetter) => firstLetter.toUpperCase());
};
